<template>
  <div class="loading-screen">
    <h1>KRIENS</h1>
    <div class="loading-screen__spinner">
      <svg version="1.1" id="loading-spinner" xmlns="http: //www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
        width="40px" height="40px" viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;" xml:space="preserve">
      <path fill="#000" d="M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z"></path>
      </svg>
    </div>
  </div>
</template>

<script>
import EventBus from '../EventBus'

export default {
  name: 'LoadingScreen',
  created () {
    EventBus.$on(EventBus.constants.HIDE_LOADING_SCREEN, () => this.hideLoadingScreen())
    EventBus.$on(EventBus.constants.SHOW_LOADING_SCREEN, () => this.showLoadingScreen())
  },
  methods: {
    async hideLoadingScreen () {
      $('.loading-screen').addClass('state-hidden')
      await this.sleep(1000)
      $('.loading-screen').hide()
    },
    async showLoadingScreen () {
      $('.loading-screen').show()
      $('.loading-screen').removeClass('state-hidden')
    },
    sleep (ms) {
      return new Promise(resolve => setTimeout(resolve, ms))
    }
  }
}
</script>